import { BottomNavigation, BottomNavigationAction, Box, Paper, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { resetEntityState } from '../Common/Entity/actions/reduxActions';
import { getSelectedEntityStatus } from '../Reducers/Entity/EntityReducer';
import { toast } from 'react-toastify';
import { STATUS } from '../Common/Entity/Enums';

const BottomTabBar = ({ 
  tabConfig, 
  firmOnboarded, 
  manufacturerSelected = null,
  onFirmModalShow = null,
  onManufacturerModalShow = null,
  onTabChange
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentPath = location.pathname;

  const entityStatus = useSelector(getSelectedEntityStatus);
  const { selectedEntityInfo } = useSelector(
    (state) => state.entityReducer
  );
  const handleTabChange = (event, newValue) => {
    if (newValue === "/") {
      if(onTabChange){
        onTabChange(newValue);
      }else{
        navigate("/");
      }
      return;
    }
    if (entityStatus === STATUS.PENDING) {
      toast.warning("Your request is pending, waiting for manufacturer's approval");
      return;
    }
    if (entityStatus === STATUS.INACTIVE && selectedEntityInfo?.has_history === false) {
      if (onManufacturerModalShow) {
        onManufacturerModalShow();
      }
      return;
    }
  
    if (!firmOnboarded && onFirmModalShow) {
      onFirmModalShow();
      return;
    }
    if (firmOnboarded && !manufacturerSelected && onManufacturerModalShow) {
      onManufacturerModalShow();
      return;
    }
    if (onTabChange) {
      onTabChange(newValue);
      return;
    }
    navigate(newValue);
  };
  return (
    <>
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 999,
        border: 'none',
        boxShadow:"none",

      }}
    >
      <BottomNavigation
        value={currentPath}
        onChange={handleTabChange}
        sx={{ 
            height: 70,
            borderRadius: '16px', 
            border: 'none',
            boxShadow: '0px 2px 8px 0px #0000001A',
            p: 0,
            alignItems: 'center',
            justifyContent: 'center',
        }}
      >
        {tabConfig.map((tab) => {
            const isSelected = currentPath === tab.route;
            return (
                <BottomNavigationAction
                    key={tab.key}
                    label={tab.label}
                    value={tab.path}
                    icon={isSelected ? tab.activeIcon : tab.inactiveIcon}
                    showLabel
                    sx={{
                      padding: 0,
                      alignContent: 'center',
                      minWidth: 'unset',
                      ".MuiBottomNavigationAction-label": {
                        fontSize: "11px",
                        transition: "none",
                        lineHeight: "20px",
                        fontWeight: 600,
                        color: isSelected ? "#995A00" : "#666666",
                      },
                      "&.Mui-selected": {
                        ".MuiBottomNavigationAction-label": {
                          color: "#995A00",
                          fontSize: "11px",
                          fontWeight: 600,
                        },
                        ".MuiSvgIcon-root": {
                          color: "#995A00",
                        },
                      },
                    }}
                />
            );
        })}
      </BottomNavigation>
    </Paper>
    </>
  );
};

export default BottomTabBar;

